import React from 'react';
import { useDayPicker } from 'react-day-picker';
import getUnixTime from 'date-fns/getUnixTime';

import styles from './Row.module.scss';

const Row = ({ dates, displayMonth }: { dates: any; displayMonth: any }) => {
  const { components } = useDayPicker();

  const DayComponent = components.Day;

  return (
    <div className={styles.row}>
      {dates.map((date: any) => (
        <div
          className={styles.cell}
          key={getUnixTime(date)}
          role="presentation"
        >
          <DayComponent displayMonth={displayMonth} date={date} />
        </div>
      ))}
    </div>
  );
};

export default React.memo(Row) as any;
